import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div>Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userRole = (user?.role || user?.perfil || '').toString().trim().toUpperCase();
  const allowed = (allowedRoles || []).map((role) => role.toUpperCase());

  if (allowedRoles && user && !allowed.includes(userRole) && userRole !== 'ADMIN') {
    try {
      sessionStorage.setItem('acesso_negado_role', userRole || '');
      sessionStorage.setItem('acesso_negado_allowed', JSON.stringify(allowedRoles || []));
      sessionStorage.setItem('acesso_negado_path', location.pathname || '');
    } catch {
      // ignore storage errors
    }
    return <Navigate to="/acesso-negado" replace />;
  }

  return children;
};

export default PrivateRoute;
